import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {URL_IMG} from '../../../configs/urlConfigs';
import {MSG_REQUIRED, MSG_NOT_FOUND, MSG_PAY_LEVEL_OMNU_ADD_SUCCESS, MSG_PAY_LEVEL_OMNU_UPDATE_SUCCESS ,MSG_PAY_LEVEL_OMNU_DELETE_SUCCESS} from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_BTN_ADDNEW,LBL_OMNU_POINTS_AGAINST_PP_TITLE,LBL_SLNUM, LBL_PP_FROM, LBL_PP_TO, LBL_OMNU_POINTS, LBL_ACTIONS,LBL_EDIT,LBL_DELETE,LBL_CONFIRM_DELETE } from '../../../configs/labelConfigs';
import {ROUTE_REFRESH} from '../../../configs/staticConfigs';
import * as types from '../../../actions';

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import {formValid,checkNumDotZero} from '../../../utils/validation';

import {ppSettingsListAction, ppSettingsAddAction, ppSettingsEditAction, ppSettingsUpdateAction, ppSettingsDeleteAction} from '../../../actions/settings/superadmin/ppSettingsActions';
import {clearAction} from '../../../actions/commonActions';

class ppSettingsComponent extends Component { 

    constructor(props){
        super()

        this.state = {
            activeRowId:0,            
            formErrors:{
                ppFrom: "",
                ppTo:"",
                omnuPoints:""
            },          
            ppOmnuData:{
                id:'',
                ppFrom: null,
                ppTo:null,
                omnuPoints:null,
            },
            payLevelName:'',     
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.modalDelete = React.createRef();
        this.modal = React.createRef();

        
    }    
    
    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.ppFrom = '';
        formErrors.ppTo = '';   
        formErrors.omnuPoints = '';   
        this.setState({formErrors});
        this.modal.current.handleOpenModal();
    }      

    onModalFormReset = () =>{       
        this.setState({ppOmnuData:{
            id:'',
            ppFrom: null,
            ppTo:null,
            omnuPoints:null,
        },
        payLevelName:''
        }); 
    }

    onHandleChange = (event) =>{

        const {name} = event.target;
        let trimmedValue = '';

        const value = event.target.value;  
        
        if(event.target.type==="text"){
            trimmedValue = value.trim(); 
        }

        let formErrors     = this.state.formErrors;
        let ppOmnuData      = this.state.ppOmnuData;
        switch(name){
            case 'ppFrom':
                formErrors.ppFrom = 
                trimmedValue.length <=0 || !checkNumDotZero(trimmedValue)
                ? MSG_REQUIRED
                : ""
                break;
            case 'ppTo':
                    formErrors.ppTo = 
                    trimmedValue.length <=0 || !checkNumDotZero(trimmedValue) || trimmedValue<= ppOmnuData['ppFrom']
                    ? MSG_REQUIRED
                    : ""
                break;

            case 'omnuPoints':
                formErrors.omnuPoints = 
                trimmedValue.length <=0 || !checkNumDotZero(trimmedValue)
                ? MSG_REQUIRED
                : ""
            break;
            
            default :
            break;
        }

        ppOmnuData[name] = value;
      
        this.setState({formErrors,ppOmnuData});

    }    

    onShowActionButtons = (event, rowId) =>{

        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        } 
    }    

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) =>{

        const {ppOmnuData} = this.state;
        if(formValid(this.state)){            
            let data= {
                pp_from: ppOmnuData.ppFrom,
                pp_to: ppOmnuData.ppTo,
                omnu_point: ppOmnuData.omnuPoints,
            }
            if(id){
                data['payId']= id;
                this.props.ppSettingsUpdateAction(data);               
            }else{
                this.props.ppSettingsAddAction(data);
            }               
        }else{
            let formErrors = this.state.formErrors;
            if(ppOmnuData.ppFrom==null){
                formErrors.ppFrom = MSG_REQUIRED;
            } 
            if(ppOmnuData.ppTo===null){
                formErrors.ppTo = MSG_REQUIRED;
            } 
            if(ppOmnuData.omnuPoints===null){
                formErrors.omnuPoints = MSG_REQUIRED;
            } 
            this.setState({formErrors});
        }
       
    }    

    editBtnClick = (rowId) =>{        
        let formErrors = this.state.formErrors;    
        formErrors.ppFrom = '';
        formErrors.ppTo = '';   
        formErrors.omnuPoints = '';   
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.ppSettingsEditAction(rowId);
    }

    deleteBtnClick = (rowId,ppFrom,ppTo) =>{
        this.setState({
            ppOmnuData: {
                id: rowId,
            },
            payLevelName:ppFrom+'-'+ppTo           
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let id = this.state.ppOmnuData.id;
        this.props.ppSettingsDeleteAction(id);
        this.modalDelete.current.handleModelClose();                    
    }
 
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }   
    
    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }
      
    setStateUpdate(omnuppSettings,status,activity,numRows,totalPage,errorData){
        let formErrors = this.state.formErrors;
        if(activity===types.OMNU_POINTS_PP_ADD_SUCCESS){
            this.modal.current.handleModelClose();
            this.props.ppSettingsListAction();
            this.setToasterState(true,MSG_PAY_LEVEL_OMNU_ADD_SUCCESS,true);
        }else if(activity===types.OMNU_POINTS_PP_ADD_ERROR){
            if(status===400){
                if(errorData.hasOwnProperty('name')){ 
                    formErrors.name = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }                
            }
        }else if(activity===types.OMNU_POINTS_PP_UPDATE_SUCCESS){
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_PAY_LEVEL_OMNU_UPDATE_SUCCESS,true);
        }else if(activity===types.OMNU_POINTS_PP_UPDATE_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){  
                    formErrors.name = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
            }
        }else if(activity===types.OMNU_POINTS_PP_EDIT_SUCCESS){  
            this.setState({ppOmnuData:{
                id:omnuppSettings.id,           
                ppFrom: omnuppSettings.ppFrom,
                ppTo:omnuppSettings.ppTo,
                omnuPoints:omnuppSettings.omnuPoints,
            }});  
        }else if(activity===types.OMNU_POINTS_PP_DELETE_SUCCESS){          
            this.props.ppSettingsListAction();                     
            this.setToasterState(true,MSG_PAY_LEVEL_OMNU_DELETE_SUCCESS,true);                   
        }else if(activity===types.OMNU_POINTS_PP_DELETE_ERROR){
            this.setToasterState(true,JSON.stringify(errorData),false);
        }
    }
    
    componentDidUpdate(prevProps) {    
        const { omnuppSettings,status,activity,numRows,totalPage,errorData} = this.props;
        if (activity !== prevProps.activity) {
            this.setStateUpdate(omnuppSettings,status,activity,numRows,totalPage,errorData);
            this.props.clearAction();
        }
    } 

    componentDidMount() { 
        this.props.ppSettingsListAction();  
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_OMNU_POINTS_AGAINST_PP_TITLE;      
    }  
       
    render(){

        const {
            toastMessage,toastFlag,toastSuccess,ppOmnuData           
        } = this.state    
        
        const { omnuList,status} = this.props;       

        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }
        return(        

            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">                            
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th>{LBL_PP_FROM}</th>
                                        <th>{LBL_PP_TO}</th>
                                        <th>{LBL_OMNU_POINTS}</th>
                                        <th>{LBL_ACTIONS}</th>
                                    </tr>  
                                </thead>
                                <tbody>
                                {(omnuList.length===0) && 
 
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                { omnuList.map((item,index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.pp_from}</td>
                                            <td>{item.pp_to}</td>
                                            <td>{item.omnu_point}</td>
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                    >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.pp_from,item.pp_to)}>{LBL_DELETE}</Link> 
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                                                         
                                </tbody>
                            </table> 

                            <div className="clear-b-scroll-sector">&nbsp;</div>
                        </div>
                    </div>
                </div>   

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete pay level "+this.state.payLevelName+"?"}
                </ModalWindow>


                <ModalWindow ref={this.modal} header="Add/Edit Pay Level" saveFormData={ (e)=>this.onSaveFormData(ppOmnuData.id)} resetModalForm={this.onModalFormReset} type="save">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>PP From</label>
                                <div className="text-input"><input className={this.state.formErrors.ppFrom.length >0 ? "input-error" : ''} name="ppFrom" type="text" placeholder="" value={ppOmnuData.ppFrom || ''} onChange={this.onHandleChange} maxLength = {120} /></div>
                                {this.state.formErrors.ppFrom.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrors.ppFrom}</div>
                                )} 
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>PP To</label>
                                <div className="text-input"><input className={this.state.formErrors.ppTo.length >0 ? "input-error" : ''} name="ppTo" type="text" placeholder="" value={ppOmnuData.ppTo || ''} onChange={this.onHandleChange} maxLength = {120}/></div>
                                {this.state.formErrors.ppTo.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrors.ppTo}</div>
                            )} 
                            </div>
                        </div>
                    </div>     
                    <div className="row">                      
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>OMNU Points</label>
                                <div className="text-input"><input className={this.state.formErrors.omnuPoints.length >0 ? "input-error" : ''} name="omnuPoints" type="text" placeholder="" value={ppOmnuData.omnuPoints || ''} onChange={this.onHandleChange} maxLength = {120}/></div>
                                {this.state.formErrors.omnuPoints.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrors.omnuPoints}</div>
                            )} 
                            </div>
                        </div>
                    </div>                  
                </ModalWindow>           
            
            </div>
        )
        
    }
    
}

const mapStateToProps = (state) => {
    return {
        omnuList : state.omnuppSettings.items,
        totalPage:state.omnuppSettings.totalPage,
        omnuppSettings:state.omnuppSettings.item,
        status:state.omnuppSettings.status,
        activity:state.omnuppSettings.activity,
        numRows:state.omnuppSettings.numRows,
        count:state.omnuppSettings.count,
        errorData:state.omnuppSettings.errorData
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        ppSettingsListAction:ppSettingsListAction,  
        ppSettingsAddAction:data=>ppSettingsAddAction(data),
        ppSettingsEditAction:id=>ppSettingsEditAction(id),
        ppSettingsUpdateAction:data=>ppSettingsUpdateAction(data),
        ppSettingsDeleteAction:id =>ppSettingsDeleteAction(id),
        clearAction:clearAction           
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ppSettingsComponent);